import React, { useState, useEffect } from "react";

function Guitar(props) {
  const [isPlaying, setIsPlaying] = useState(false); // Track whether the guitar is playing

  useEffect(() => {
    // This effect handles the play/pause icon switching logic.
    const playIcon = document.querySelector('.play-icon');
    const pauseIcons = document.querySelectorAll('.pause-icon');

    // On every render, we update the icons based on the current play/pause state.
    if (isPlaying) {
      playIcon.style.stroke = "#23ffde"; // Change play icon color when playing
      pauseIcons.forEach((icon) => icon.style.display = "none"); // Hide pause icons when playing
    } else {
      playIcon.style.stroke = "#FDFFFC"; // Default color for play icon when paused
      pauseIcons.forEach((icon) => icon.style.display = "block"); // Show pause icons when paused
    }
  }, [isPlaying]); // Re-run the effect whenever 'isPlaying' changes

  const togglePlayPause = () => {
    setIsPlaying((prev) => !prev); // Toggle the play/pause state
  };
  return (
    <>
      <svg viewBox="470 300 1200 1400" {...props}>
        <ellipse opacity={0.3} cx={833.5} cy={1408.3} rx={250.9} ry={25.8} />
        <path
          fill="#0891BA"
          stroke="#333"
          strokeWidth={9}
          strokeMiterlimit={10}
          d="M1085.3 1398c0 6.6-5.4 12-12 12H593.7c-6.6 0-12-5.4-12-12V918.4c0-6.6 5.4-12 12-12h479.6c6.6 0 12 5.4 12 12V1398z"
        />
        <path
          opacity={0.9}
          fill="#39A7C8"
          d="M1073.3 910.8H593.7c-3.4 0-6.3 2.3-7.2 5.5h494c-.9-3.2-3.8-5.5-7.2-5.5z"
        />
        <path
          fill="#FFD192"
          stroke="#333"
          strokeWidth={9}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          d="M1064.8 1378.5c0 6.1-4.9 11-11 11H613.3c-6.1 0-11-4.9-11-11V938c0-6.1 4.9-11 11-11h440.5c6.1 0 11 4.9 11 11v440.5z"
        />
        <circle
          fill="#2EC4B6"
          stroke="#333"
          strokeWidth={9}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          cx={833.5}
          cy={1158.2}
          r={189.3}
        />
        <circle
          fill="#0891BA"
          stroke="#333"
          strokeWidth={9}
          strokeMiterlimit={10}
          cx={833.5}
          cy={1158.2}
          r={169.2}
        />
        <circle
          id="speaker-2"
          fill="#FDFFFC"
          stroke="#333"
          strokeWidth={9}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          cx={833.5}
          cy={1158.2}
          r={118.1}
        />
        <g className="play">
          <circle
            id="speaker-1"
            fill="#E71D36"
            stroke="#333"
            strokeWidth={9}
            strokeMiterlimit={10}
            cx={833.5}
            cy={1158.2}
            r={58}
          />
          <polyline
            className="play-icon"
            fill="none"
            stroke="#23ffde"
            strokeWidth="7"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            points="820,1138 860,1158 820,1178 820,1152"
          />
          <g className="pause-icon">
            <rect
              id="pause-1"
              fill="#23ffde"
              x="817"
              y="1137"
              width="12"
              height="44"
            ></rect>
            <rect
              id="pause-2"
              fill="#23ffde"
              x="840"
              y="1137"
              width="12"
              height="44"
            ></rect>
          </g>
        </g>
        <g fill="none">
          <circle cx={833.5} cy={1158.2} r={124} />
          <circle cx={833.5} cy={1158.2} r={62} />
        </g>
        <g fill="#333">
          <path d="M962.9 1028.9c-1.3-1.3-3.6-1.3-4.9 0-1.4 1.4-1.4 3.6 0 4.9.7.7 1.5 1 2.5 1s1.8-.4 2.5-1c1.2-1.3 1.2-3.6-.1-4.9zM709.1 1282.6c-1.3-1.3-3.6-1.3-4.9 0-1.4 1.4-1.4 3.6 0 4.9.7.7 1.5 1 2.5 1s1.8-.4 2.5-1c1.3-1.3 1.3-3.5-.1-4.9zM962.9 1282.6c-1.3-1.3-3.6-1.3-4.9 0-1.4 1.4-1.4 3.6 0 4.9.7.7 1.5 1 2.5 1s1.8-.4 2.5-1c1.2-1.3 1.2-3.5-.1-4.9zM709.1 1028.9c-1.3-1.3-3.6-1.3-4.9 0-1.4 1.4-1.4 3.6 0 4.9.7.7 1.5 1 2.5 1s1.8-.4 2.5-1c1.3-1.3 1.3-3.6-.1-4.9z" />
        </g>
        <g>
          <path
            fill="#0891BA"
            stroke="#333"
            strokeWidth={9}
            strokeMiterlimit={10}
            d="M1085.3 894.6c0 6.6-5.4 12-12 12H593.7c-6.6 0-12-5.4-12-12V718.8c0-6.6 5.4-12 12-12h479.6c6.6 0 12 5.4 12 12v175.8z"
          />
          <path
            opacity={0.9}
            fill="#39A7C8"
            d="M1073.3 711.3H593.7c-3.4 0-6.3 2.3-7.2 5.5h494c-.9-3.2-3.8-5.5-7.2-5.5z"
          />
          <path
            fill="#FFD192"
            stroke="#333"
            strokeWidth={9}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit={10}
            d="M1064.8 877.9c0 5.4-4.9 9.7-11 9.7H613.3c-6.1 0-11-4.4-11-9.7V735.5c0-5.4 4.9-9.7 11-9.7h440.5c6.1 0 11 4.4 11 9.7v142.4z"
          />
          <path
            fill="#FDFFFC"
            stroke="#333"
            strokeWidth={9}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit={10}
            d="M1013.3 831.5c0-4.2-3.8-7.6-8.6-7.6H662.3c-4.7 0-8.6 3.4-8.6 7.6v56.1h359.6v-56.1z"
          />
          <circle
            fill="#2EC4B6"
            stroke="#333"
            strokeWidth={6}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit={10}
            cx={976.6}
            cy={855.7}
            r={11.6}
          />
          <path
            fill="#333"
            d="M980.8 850.3c-.8-.8-2.1-.8-2.8 0-.8.8-.8 2 0 2.8.4.4.9.6 1.4.6s1-.2 1.4-.6c.8-.8.8-2.1 0-2.8z"
          />
          <circle
            fill="#2EC4B6"
            stroke="#333"
            strokeWidth={6}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit={10}
            cx={905.1}
            cy={855.7}
            r={11.6}
          />
          <path
            fill="#333"
            d="M909.2 850.3c-.8-.8-2.1-.8-2.8 0-.8.8-.8 2 0 2.8.4.4.9.6 1.4.6s1-.2 1.4-.6c.8-.8.8-2.1 0-2.8z"
          />
          <circle
            fill="#2EC4B6"
            stroke="#333"
            strokeWidth={6}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit={10}
            cx={833.5}
            cy={855.7}
            r={11.6}
          />
          <path
            fill="#333"
            d="M833.8 850.8c-.2-1-1-1.7-2-1.7h-.3c-.5.1-1 .4-1.3.8-.3.4-.4 1-.3 1.5.2 1 1 1.7 2 1.7h.3c1-.2 1.7-1.2 1.6-2.3z"
          />
          <g>
            <circle
              fill="#2EC4B6"
              stroke="#333"
              strokeWidth={6}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit={10}
              cx={761.9}
              cy={855.7}
              r={11.6}
            />
            <path
              fill="#333"
              d="M768 852.5c-.4-1-1.6-1.6-2.6-1.2-.5.2-.9.5-1.1 1-.2.5-.3 1-.1 1.5.3.8 1 1.3 1.9 1.3.2 0 .5 0 .7-.1.5-.2.9-.5 1.1-1 .3-.4.3-1 .1-1.5z"
            />
          </g>
          <g>
            <circle
              fill="#2EC4B6"
              stroke="#333"
              strokeWidth={6}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit={10}
              cx={690.4}
              cy={855.7}
              r={11.6}
            />
            <path
              fill="#333"
              d="M687.7 851.6c-.8-.8-2.1-.8-2.8 0-.8.8-.8 2 0 2.8.4.4.9.6 1.4.6s1-.2 1.4-.6c.8-.8.8-2 0-2.8z"
            />
          </g>
          <g>
            <path
              fill="#333"
              d="M935 743c-1.1-1.2-2.7-1.9-4.4-1.9-.3 0-.5 0-.8.1l-10 1.4c-.8.1-1.5.4-2.2.8-.1-.1-.1-.2-.2-.2-1.1-1.2-2.7-1.9-4.4-1.9-.3 0-.5 0-.8.1l-10 1.4c-2.5.3-4.5 2.2-5.1 4.7l-1.7 8.1c-.8-.4-1.8-.7-2.7-.7H883c-.7 0-1.5.1-2.1.4-.9-.2-1.9-.3-2.8-.3-6 0-11.1 2.2-15.1 6.1-2.3-3.5-6.5-6.1-13.9-6.1-.9 0-1.7.1-2.6.2-.6-.2-1.2-.3-1.9-.3h-9.7c-2.8 0-5.3 2-5.9 4.8v.2c-2.6-3-6.2-5-10.1-5-2.8 0-5.8.9-9 2.6-2.3-1.7-4.9-2.6-7.6-2.6-1.6 0-3.2.3-4.9.8-.9-.5-1.9-.8-3-.8H786l1.9-8.7c.6-2.8-.9-5.7-3.6-6.8-2.2-.9-5.1-1.5-7.7-1.5-6.2 0-15.7 3.6-26.7 20h-.8c-10.6 0-19.2 6.2-19.2 13.8 0 5.8 3.7 9.2 7.8 10.1-1.8 5.1-2.8 9.6-2.8 13 0 6.7 3.1 9.9 5.6 11.5 2.9 1.7 6.1 1.9 8.9 2.1h.5c1.6 0 3.2-.7 4.4-1.9 1.2-1.3 1.8-3 1.6-4.8-.1-1.1-.5-2-.9-2.7v-.5c0-3.1.9-7.9 2.5-13.1l-1.7 8c-.4 1.8.1 3.6 1.2 5 1.1 1.4 2.9 2.2 4.7 2.2h9.7c1.1 0 2.1-.3 3-.8.9.5 2 .8 3 .8h9.7c1.5 0 2.9-.6 4-1.5 1.1 1 2.5 1.5 4 1.5h9.8c2.7 0 5-1.8 5.8-4.4 2.2 2.5 5.5 4 9.6 4.3l-2.1 9.7c-.4 2 .2 4.1 1.7 5.5 1.1 1.1 2.6 1.7 4.2 1.7.5 0 .9-.1 1.4-.2l10.2-2.4c2.3-.5 4-2.3 4.5-4.6l2.1-9.9c.6.1 1.3.1 1.9.1 4.9 0 9.3-1.8 12.7-5.3 2.5 3.6 6.6 5.7 11.8 5.7 2.4 0 5.4-.6 8.6-2.7 2.1 1.3 4.9 2.3 8.8 2.3 2.8 0 5.4-1 8-2.7 2.4 1.7 5.6 2.7 9.3 2.7 2.7 0 5.4-1 8-2.7 2.2 1.7 4.9 2.7 8.2 2.7 6.2 0 10.4-3.3 12.7-10.1.2-.6.4-1.4.4-2.1 0-2.4-1.5-4.5-3.5-5.5l7.3-34.4c.4-1.9-.1-3.9-1.5-5.3z"
            />
            <path
              fill="#FDFFFC"
              d="M776.6 743.6c-8 0-16.8 9.3-23.6 20.2-1.5-.1-2.8-.2-4-.2-7 0-13.2 3.6-13.2 7.8 0 3 1.9 4.3 3.9 4.3 2.9 0 4.1-1.2 4.1-2.6 0-.9-.5-2.1-.9-2.1.9-2.4 3.9-3.2 7.9-3.5-5.9 10.3-9.9 21.3-9.9 27 0 7.2 4.4 7.3 9.1 7.6-.1-.6-.9-.3-.9-3.8 0-7 3.6-19.9 8.7-30.8 2.9.2 5.7.9 9.1 2.4l-5.2 24.5h9.7l10.6-49.7c-1.6-.7-3.8-1.1-5.4-1.1zm-9.1 23.3c-2.6-1-5.5-1.8-8.4-2.3 3.8-7.6 8.2-13.9 12.3-16.1l-3.9 18.4zM849.1 760.7c-1.7 0-3.3.5-4.7 1.2l.3-1.3H835l-5.7 26.8c-1 .9-2 1.4-3 1.4-2.2 0-2.8-1.2-2.8-2.8 0-.8.1-1.7.3-2.5l2.8-12.9c.1-.5.1-1 .1-1.6 0-4.6-4.1-8.5-7.8-8.5-3.3 0-6.9 2.1-9.9 4.5-1.5-2.6-4.2-4.5-6.7-4.5-2.9 0-6 1.6-8.7 3.6l.7-3.6h-9.7l-7.2 33.8h9.7l5.8-27.3c1.4-.9 2.5-1.4 4.1-1.4 1.8 0 3.1 1.6 3.1 4 0 .5-.1 1.1-.2 1.8l-4.9 23h9.8l5-23.7c.1-.5.1-.9.1-1.4 0-.8-.1-1.6-.3-2.4 1.3-.8 2.4-1.2 3.9-1.2 1.8 0 3.1 1.6 3.1 4 0 .5-.1 1.1-.2 1.8l-2.6 12.2c-.3 1.3-.4 2.4-.4 3.4 0 5.1 3.1 7.4 8.4 7.4 2.1 0 4.3-1.4 6.4-3.3l-4.3 20.2 10.2-2.4 3.5-16.6c2 1.3 4.1 2 6.4 2 6.9 0 12.7-4.9 14.8-19.5.3-1.8.4-3.3.4-4.7.2-7-3.1-9.5-10.1-9.5zm1.3 15c-2.2 10.7-3.9 13.7-7.2 13.7-1.1 0-2.8 0-4.4-1.2l4.9-22.7c1.3-.9 2.6-1.4 3.9-1.4 2.2 0 3.8.8 3.8 4.9-.2 1.5-.4 3.7-1 6.7zM922.5 785.9c0-.7.1-1.5.3-2.3l7.8-36.5-10 1.4-7.4 35.1c-.2.8-.3 1.7-.3 2.5-1.6 1.2-3.1 2.2-4.5 2.2-2.6 0-3.4-1-3.4-2.5 0-.5.1-1.1.3-2.2l7.8-36.5-10 1.4-7.5 35.1c-.2 1-.3 1.9-.4 2.7-1.5 1.1-2.9 2-4.2 2-2.7 0-3.4-1.1-3.4-2.6 0-.6.1-1.4.3-2.1l4.9-23H883l-.4 1.8c-1.2-1-2.9-1.7-4.5-1.7-13.5 0-17.7 13.9-17.7 25.5 0 4 1.9 8.6 8.4 8.6 4.1 0 7.2-2.8 9.2-5.5.9 3.5 3.9 5.1 8.2 5.1 2.8 0 6.2-2.5 9.2-5.2.8 3.6 3.7 5.2 8.2 5.2 2.8 0 6.3-2.6 9.4-5.4.6 3.2 2.7 5.4 6.7 5.4 2.3 0 5.1-.4 7-6.2-.5.2-1.3.2-1.8.2-1.8 0-2.4-1.1-2.4-2.5zm-44.4-2.3c-.2.8-.3 1.6-.4 2.2-1.3 1.9-2.8 3.4-4.3 3.4-1.7 0-3.9-.7-3.9-4.8 0-9.2 4.1-19.9 9.1-19.9.9 0 2.2.3 3.3 1.2l-3.8 17.9z"
            />
          </g>
        </g>
        <g id="sparks">
          <g className="sparks" id="spark-4">
            <path
              fill="#FDE74C"
              d="M907.8 1098.8c-1 0-2-.5-2.6-1.4-.8-1.3-.5-2.9.6-3.9l29.5-25-7.4-3.9c-.9-.5-1.5-1.4-1.6-2.4-.1-1 .4-2 1.2-2.6l45-32.4c.5-.4 1.1-.6 1.8-.6.5 0 1 .1 1.4.4l21 11.2c.9.5 1.5 1.4 1.6 2.4.1 1-.4 2-1.2 2.6l-26.3 19 5.6 3c1 .5 1.6 1.6 1.6 2.8-.1 1.2-.8 2.2-1.8 2.6l-67.3 28.1c-.3 0-.7.1-1.1.1z"
            />
            <path d="M974.4 1029.4l21 11.2-30.2 21.8 9.9 5.3-67.3 28.1 32.8-27.9-11.3-6 45.1-32.5m0-6c-1.2 0-2.5.4-3.5 1.1l-45 32.4c-1.7 1.2-2.6 3.2-2.5 5.3.1 2.1 1.3 3.9 3.2 4.9l3.5 1.8-26.1 22.2a5.87 5.87 0 00-1.2 7.7c1.1 1.8 3.1 2.9 5.1 2.9.8 0 1.6-.2 2.3-.5l67.3-28.1c2.1-.9 3.6-2.9 3.7-5.3s-1.1-4.5-3.2-5.6l-1.4-.7 22.4-16.1c1.7-1.2 2.6-3.2 2.5-5.3-.1-2.1-1.3-3.9-3.2-4.9l-21-11.2c-1-.3-2-.6-2.9-.6z" />
          </g>
          <g className="sparks" id="spark-3">
            <path
              fill="#FDE74C"
              d="M774 1085c-.6 0-1.1-.2-1.6-.5l-61.1-39.7c-1-.6-1.5-1.8-1.3-2.9s1-2.1 2.1-2.5l6.1-1.9-22.5-23.4c-.7-.7-1-1.8-.7-2.8.3-1 1-1.8 2-2.1l22.7-7.2c.3-.1.6-.1.9-.1.8 0 1.6.3 2.2.9l38.4 40c.7.7 1 1.8.7 2.8-.3 1-1 1.8-2 2.1l-8 2.5 24.5 29.9c.9 1.1.9 2.8-.1 3.9-.7.7-1.5 1-2.3 1z"
            />
            <path d="M720.4 1004.8l38.4 40-12.2 3.9L774 1082l-61.1-39.7 10.7-3.4-25.8-26.8 22.6-7.3m0-6c-.6 0-1.2.1-1.8.3l-22.7 7.2c-2 .6-3.5 2.2-4 4.2s.1 4.1 1.5 5.6l19.1 19.9-1.5.5c-2.2.7-3.8 2.6-4.1 4.9s.7 4.6 2.7 5.8l61.1 39.7c1 .7 2.1 1 3.3 1 1.7 0 3.3-.7 4.5-2 2-2.2 2-5.5.2-7.8l-21.7-26.5 3.7-1.2c2-.6 3.5-2.2 4-4.2s-.1-4.1-1.5-5.6l-38.4-40c-1.2-1.1-2.8-1.8-4.4-1.8z" />
          </g>
          <g className="sparks" id="spark-1">
            <path
              fill="#FDE74C"
              d="M670.6 1261.3c-.7 0-1.4-.3-2-.8l-17.7-15.9c-.8-.7-1.1-1.7-1-2.8.2-1 .9-1.9 1.8-2.3l30.1-12.1-4.8-4.3c-.9-.8-1.2-2-.9-3.1.3-1.1 1.3-1.9 2.4-2.1l72-11.2h.5c1.3 0 2.5.8 2.9 2.1.4 1.4-.2 2.9-1.5 3.6l-34.6 17.3 6.2 5.6c.8.7 1.1 1.7 1 2.8-.2 1-.9 1.9-1.8 2.3l-51.4 20.7c-.4.2-.8.2-1.2.2z"
            />
            <path d="M751.1 1209.9l-38.6 19.2 9.5 8.5-51.4 20.7-17.7-15.9 34.5-13.9-8.3-7.5 72-11.1m0-6h-.4c-.2 0-.4 0-.6.1l-71.9 11.2c-2.3.4-4.2 2-4.8 4.2-.7 2.2 0 4.6 1.7 6.2l1.2 1-25.6 10.3c-1.9.8-3.3 2.5-3.7 4.5-.4 2 .4 4.1 1.9 5.5l17.7 15.9c1.1 1 2.6 1.5 4 1.5.8 0 1.5-.1 2.2-.4l51.4-20.7c1.9-.8 3.3-2.5 3.7-4.5s-.4-4.1-1.9-5.5l-2.9-2.6 30.5-15.2c.5-.2.9-.5 1.3-.8.1-.1.2-.2.4-.3 1.1-1.1 1.8-2.6 1.8-4.3 0-3.1-2.4-5.7-5.5-6-.1-.1-.3-.1-.5-.1z" />
          </g>
        </g>
        <ellipse
          id="shadow"
          opacity={0.3}
          cx={1088.3}
          cy={1527.6}
          rx={227.9}
          ry={12}
        />
        <g id="guitar_2_">
          <path
            fill="#E71D36"
            d="M1097.3 1481.4c-39.4-.5-78.4-21-108-38.8-59.6-35.9-83.8-61.4-98.3-79.6-7.1-9-13.1-18.4-17.7-28-13.7-28.4-13.4-57.8 1.1-87.3 15.3-31.3 42.3-54.9 62.3-69.3 35.2-25.2 61-48.4 74.5-67 .2-.3.3-.5.4-.6 9.4-12.3 18.2-49.5 23.9-78.6 10.4-53 24.5-74.6 35.6-87.6 7.3-8.5 23.2-22.9 36.4-22.9 4 0 7.4 1.4 10.3 4.3 6.4 6.4.2 19.8-4.8 30.6-1.5 3.2-2.9 6.3-3.9 9-9.3 25.2-1.3 48.4 10 59.3 9.1 8.8 18.6 12.7 30.8 12.7 4.9 0 10.2-.6 16.8-1.9l28.4 47.3c-3.2 7.4-5.2 17.6-5.5 24.5-.2 5.4 1 10.4 3.7 15.5 7.6 14.3 23.8 23.2 42.2 23.2 2.8 0 5.6-.2 8.3-.6 14.6-2.3 23.8-10.7 32.7-18.8 5.1-4.6 9.9-9 15.6-12.3 2-1.2 4-1.8 6-1.8 5.8 0 11.3 5.5 13 13 1.5 6.7-.4 14.5-2.6 21.3-4.4 13.8-12.9 25.6-20.6 35.2-5.5 6.9-13 12.1-21 17.7-4 2.8-8.2 5.8-12.1 8.9-28 22.8-41.8 46.2-44.7 76.1-.9 8.9-1.2 17.9-1.5 26.6-.2 7.3-.5 14.9-1.1 22.3-1.7 20.7-4.8 38.9-9.7 55.7-9.4 32.6-36.9 72.7-71.2 86.4-8.8 3.5-19.5 5.6-28.7 5.6l-.6-.1z"
          />
          <path
            fill="#EC4A5E"
            d="M1107.5 927.7c2.4 0 4.2.8 6.1 2.6 3.4 3.4-3 17.2-6 23.8-1.6 3.3-3 6.5-4.1 9.4-7.2 19.4-6.6 48.3 11.4 65.7 10.2 9.8 21.3 14.3 35 14.3 4.2 0 8.6-.4 13.8-1.3l24.7 41.2c-3.1 8.4-4.6 18.1-4.8 23.7-.3 6.4 1.2 12.6 4.4 18.6 8.7 16.3 26.9 26.4 47.5 26.4 3.1 0 6.2-.2 9.2-.7 16.3-2.6 26.7-12 35.8-20.3 4.8-4.4 9.4-8.6 14.6-11.6 1.1-.6 2.1-1 3-1 2.9 0 6.1 3.8 7.2 8.4 1.2 5.3-.7 12.5-2.5 18.2-4.1 12.9-12.2 24.1-19.6 33.3-5 6.2-12.1 11.2-19.7 16.6-4.1 2.9-8.4 5.9-12.4 9.2-29.4 23.9-43.8 48.6-46.9 80.2-.9 9.1-1.2 18.2-1.5 27-.3 7.6-.5 14.8-1.1 22-1.6 20.3-4.7 38.1-9.4 54.5-4.7 16.3-14.2 34.2-25.9 49-12.8 16.1-27.2 27.7-41.7 33.5-8.2 3.3-18 5.2-26.4 5.2h-.7c-16.5-.2-34-4.1-53.7-11.8-15.5-6.1-31.9-14.4-51.4-26.2-21.3-12.8-37.9-24-52.4-35.3-18-14.1-32.5-28.1-44.3-42.9-6.9-8.7-12.6-17.7-17-26.8-12.9-26.7-12.5-54.3 1.1-82.1 14.7-30.2 41-53.1 60.4-67 35.8-25.6 62-49.2 75.9-68.3.2-.2.3-.4.4-.5 8.1-10.6 16.6-37.9 25.1-81.1 3.7-18.6 7.5-33.2 12.3-45.8 6-16 13.2-28.7 22-39.1 8.7-10.5 22.5-21 31.6-21m0-12c-15.3 0-32.5 15.2-40.9 25-21.4 24.9-30.8 58.8-37 90.3-12 61-20.6 73.3-22.8 76.1s-17.2 25.9-73.7 66.4c-52.5 37.6-97 98.4-65.3 164.1 5 10.4 11.3 20.1 18.4 29.1 26.7 33.6 63.5 59.1 99.9 81 32.8 19.7 72 39.2 111.1 39.7h.8c10.2 0 21.5-2.3 30.9-6.1 35.1-14 64.5-55.1 74.7-90.3 5.4-18.5 8.3-37.7 9.9-56.8 1.3-16.2 1-32.6 2.5-48.8 3-31.3 18.6-52.6 42.5-72 11.1-9 24.9-16.3 34-27.5 9.1-11.3 17.3-23.2 21.7-37.2 2.4-7.7 4.6-16.5 2.7-24.5-2.3-9.7-9.8-17.7-18.9-17.7-2.9 0-5.9.8-9 2.6-16.8 9.7-25.8 27.2-46.3 30.5-2.4.4-4.9.6-7.4.6-14.7 0-29.8-6.7-36.9-20-2.3-4.3-3.2-8.4-3-12.4.3-6.8 2.6-18.3 6.3-25l-32.3-53.8c-7.5 1.7-13.9 2.7-19.8 2.7-10.2 0-18.4-3.1-26.7-11-13.5-13-14.6-36.1-8.5-52.9 4.4-12 19.2-34.1 7.3-45.9-4-4.4-9-6.2-14.2-6.2z"
          />
          <path
            fill="#333"
            d="M997.1 1459.3c-4.3-2.4-8.6-4.9-13.3-7.7-61-36.7-86.1-63.2-101.1-82.1-7.6-9.6-14-19.7-19-29.9-15.2-31.4-14.8-63.9 1.1-96.5 16.3-33.3 44.7-58.2 65.7-73.2 33.8-24.2 59.5-47.2 72.1-64.6.3-.4.5-.6.6-.8 3-3.9 11.1-18.9 22-74.2 10.9-55.4 26-78.5 38-92.4 3.3-3.8 32.7-36.8 56.4-23.5 2 1.1 3.9 2.6 5.6 4.3 11.7 11.6 3.4 29.4-2.7 42.4-1.4 3-2.7 5.9-3.6 8.2-5.5 15-4.8 36.4 7.4 48.1 2.6 2.5 5.1 4.4 7.7 5.9 8.4 4.7 17.7 5.1 34.6 1.3 1.9-.4 3.8.4 4.8 2.1l32.3 53.8c.8 1.4.9 3.1.1 4.5-3.2 5.7-5.5 16.4-5.8 23-.1 3.4.7 6.7 2.5 10.1 2.8 5.2 6.9 9.3 12.5 12.5 7.9 4.5 17.8 6.2 27.2 4.7 11.4-1.8 19.1-8.8 27.2-16.2 5.3-4.8 10.7-9.8 17.5-13.7 7.1-4.1 14.7-4.3 21.4-.5 6.3 3.6 11.2 10.5 13.1 18.4 2.1 9.2-.2 18.7-2.8 26.9-4.9 15.5-14.1 28.2-22.5 38.6-6.4 8-14.9 14-23.1 19.7-4.1 2.9-7.9 5.6-11.5 8.5-26 21.1-38.2 41.8-40.9 69-.8 8.6-1.1 17.4-1.4 25.9-.2 7.5-.5 15.2-1.1 22.8-1.7 21.4-5 40.3-10 57.7-10.1 35-39.9 78.3-77.4 93.3-10.5 4.2-22.7 6.5-33.5 6.4-29.5-.6-61.3-10.9-100.1-32.8zm118.1-537.1c-6-3.4-14-2.4-23.5 3.1-10.8 6.2-19.3 15.6-21.7 18.4-11.2 13.1-25.5 34.9-36 88.3-8.1 41.5-16.3 68.5-23.6 78-.1.1-.3.4-.5.6-13.4 18.5-39.1 41.5-74.2 66.6-20.1 14.4-47.4 38.3-62.8 69.8-14.6 30-15 59.8-1.1 88.6 4.7 9.7 10.7 19.2 17.9 28.2 27.7 34.9 67.3 61.1 98.7 80 4.6 2.8 8.8 5.2 13 7.6 37.5 21.1 67.9 31.1 95.8 31.5 9.5.1 20.7-2 30-5.7 34.7-13.9 62.6-54.5 72.1-87.4 4.9-16.8 8-35.1 9.7-55.9.6-7.4.9-15 1.1-22.4.3-8.7.6-17.7 1.5-26.5 2.9-29.4 16.5-52.6 44.2-75.1 3.8-3.1 8-6 12-8.9 7.7-5.4 15.7-11 21.3-18 7.8-9.8 16.5-21.7 20.9-35.7 2.2-7 4.2-15.1 2.6-22.1-1.3-5.5-4.5-10.2-8.7-12.6-3.9-2.2-8.2-2.1-12.5.4-5.9 3.4-11 8-15.9 12.5-8.8 8-17.8 16.2-31.9 18.5-11.3 1.8-23.4-.3-33-5.7-6.9-3.9-12.4-9.4-16-16-2.6-4.8-3.7-9.6-3.5-14.7.3-6.9 2.4-17.3 5.7-24.6l-29.3-48.9c-14.5 3-26.6 3.4-37.8-2.9-3.3-1.9-6.4-4.2-9.6-7.2-15.6-15-15.9-40.4-9.6-57.7 1-2.6 2.4-5.7 3.9-8.9 5.2-11.2 11.7-25.1 4.5-32.3-1.2-1.3-2.4-2.2-3.7-2.9z"
          />
          <path
            fill="#FDFFFC"
            d="M1163.9 1408.7c-.2 0-1.5-.1-4.6-2.7-3.9-3.3-6.3-12.6-8.2-20.1-1-3.9-1.9-7.5-3.1-10.9-3-8.5-11.4-29.6-25.3-42.8-5.5-5.2-12-9.1-17.7-12.5l-1.1-.7c-17.7-10.7-36.1-20.7-53.8-30.5-7.6-4.2-15.5-8.5-23.2-12.8-2.3-1.3-4.7-2.5-7.1-3.7-9-4.6-18.4-9.4-21-16.9-4-11.3 0-26.3 5.7-36.1 7.9-13.7 19.8-25 31.5-35.1 3.3-2.9 6.7-5.6 10.3-8.5 4.2-3.4 8.5-6.9 12.6-10.6 22.7-20.2 40.4-46.3 52.5-77.4 2.5-6.5 4.6-12.6 6.3-18.6.8-2.6 2-4.5 2.8-5.3.1 0 .1.1.2.2 1.4 1.6 3.9 7.4 5.2 10.6 2 4.7 3.6 8.4 5.7 11.1 5 6.4 10 10.4 14.4 14 4.1 3.3 7.6 6.2 11.1 10.6 2.2 2.8 4.5 5.1 6.8 7.4 3.3 3.3 6.4 6.3 7.2 9.1 7.6 27.2 30 44.2 58.5 44.2 11.6 0 23.3-2.9 33.9-8.4 10.9-5.7 19.7-12.6 26.7-21.2-.6 1.8-1.4 3.9-2.4 6.4-.3.8-.6 1.5-.8 2.1-4.6 11.9-14.1 22-21.9 29.5-5.3 5.1-11.2 10-16.3 14-5.3 4.2-10.7 8.1-16.4 12.3l-2.1 1.5c-24.9 18-39.6 47.4-42.7 84.9-.6 7.8-.8 15.6-1 23.2l-.1 3.1c-.5 22.1-2.5 54.4-14.1 80.3-2.1 4.6-4.7 8.3-7.2 9.7-.3.4-.9.6-1.3.6z"
          />
          <path
            fill="#EEFAF9"
            d="M1121.9 1089.4c.5.8 1.1 1.6 1.6 2.3 5.7 7.3 11.4 11.9 16 15.7 3.7 3 6.7 5.4 9.5 9 2.6 3.3 5.3 6 7.7 8.3 1.6 1.5 3.9 3.8 4.6 4.9 4.6 16.2 13.9 29.6 26.8 38.7 11.9 8.4 26.3 12.8 41.7 12.8 6.8 0 13.5-.9 20.2-2.5-2.6 2.2-5.2 4.3-7.5 6.2-5.1 4.1-10.4 7.9-16 12l-2.1 1.5c-27.4 19.9-43.7 51.9-47 92.6-.7 8.1-.8 16.1-1 23.8l-.1 3.1c-.5 20.7-2.3 50.8-12.5 74.7-1-3.1-1.9-6.7-2.5-9.1-1-3.9-2-8-3.4-11.8-4-11.4-13-32.7-28-46.9-6.3-6-13.3-10.2-19.5-13.9l-1.1-.7c-17.9-10.8-36.3-20.9-54.2-30.7-7.6-4.2-15.4-8.5-23.1-12.7-2.5-1.4-5-2.7-7.4-3.9-6.2-3.2-14.6-7.5-15.9-11-2.4-6.9-.4-18.2 4.9-27.4 7.1-12.3 18.3-22.9 29.3-32.5 3.2-2.8 6.5-5.4 10-8.3 4.3-3.4 8.7-7 13-10.9 24-21.3 42.6-48.8 55.3-81.5.3-.7.5-1.2.7-1.8m-1.4-36.8c-6.2 0-10.9 6.8-12.7 13.2-1.7 6-3.8 11.9-6 17.7-11 28.2-27 53.2-49.7 73.4-7.4 6.6-15.3 12.5-22.8 19-12.7 11-25.2 23.1-33.7 37.8-7.3 12.7-11.6 30.5-6.5 44.9 4.9 13.9 21 19.7 32.8 26.3 25.6 14.3 51.6 28 76.7 43.1 5.9 3.5 12 7.1 17 11.8 10.2 9.7 18 25.6 22.7 38.7 3.7 10.5 5.4 28 14.4 35.5 3.7 3.1 7.4 5.2 11.4 5.2 2.3 0 4.7-.7 7.2-2.2 5.1-3.1 8.9-9.1 11.2-14.4 11.5-25.7 14.4-56.5 15-84.4.2-8.6.3-17.2 1-25.7 2.4-30 13.1-59 38.4-77.3 6.4-4.6 12.8-9.2 18.9-14.1 5.8-4.7 11.6-9.5 17-14.6 9.9-9.5 19.4-20.4 24.4-33.3 2.2-5.8 10.2-23.2 3.1-28.7-1.2-.9-2.4-1.3-3.6-1.3-5.4 0-11.2 7.4-14 10.8-6.5 8-14.5 14.1-23.6 18.8-9.2 4.8-19.2 7.2-29 7.2-21.3 0-41.4-11.7-48.4-36.5-2.3-8.3-10.6-13.5-15.9-20.2-8.5-10.8-17-13.8-25.5-24.7-3.2-4.1-7.4-19.3-12.5-23.3-2.7-1.9-5.1-2.7-7.3-2.7z"
          />
          <path
            fill="#333"
            d="M1293.6 1134.9c-.1.8-.3 1.6-.6 2.6-1 3.8-2.5 7.6-3.7 10.4-.3.8-.6 1.5-.8 2.1-4.7 12.1-14.3 22.4-22.2 30-5.4 5.2-11.3 10-16.4 14.1-5.3 4.3-11 8.4-16.5 12.4l-2.1 1.5c-13.2 9.5-23.5 22.2-30.6 37.7-6.2 13.4-10 28.9-11.4 46.1-.6 7.8-.8 15.6-1 23.1l-.1 3.1c-1 46.4-8.6 68.4-14.2 80.9-2.2 4.9-5.1 8.8-7.7 10.4-1.9 1.2-2.9 1.2-4.9.1-.9-.5-2-1.3-3.1-2.3-4.3-3.6-6.7-13.2-8.6-20.9-1-3.8-1.9-7.5-3.1-10.8-3-8.4-11.3-29.3-24.9-42.2-5.4-5.1-11.5-8.8-17.4-12.3l-1.1-.7c-7.6-4.6-15.8-9.4-25.3-14.7-9.5-5.3-19.1-10.6-28.5-15.8-7.6-4.2-15.5-8.5-23.2-12.8-2.3-1.3-4.7-2.5-7-3.7-2.4-1.3-5-2.5-7.3-3.9-8.3-4.7-12.6-8.8-14.4-13.8-1.8-5.2-2.2-11.7-1-18.6 1.1-6.4 3.5-13.1 6.8-18.8 8-13.8 20-25.3 31.9-35.5 3.3-2.9 6.9-5.8 10.3-8.6 4.2-3.4 8.4-6.8 12.6-10.5 22.5-20.1 40.1-45.9 52.1-76.9 2.5-6.5 4.6-12.5 6.3-18.4 1.1-3.8 3.2-6.3 4.1-6.7.1 0 .3.1.5.2l.9.6c1.5 1.5 4.3 8 5.6 11.1 1.9 4.6 3.5 8.2 5.5 10.8 4.9 6.2 9.8 10.2 14.2 13.8 4 3.2 7.7 6.3 11.3 10.9 2.1 2.7 4.5 5 6.7 7.2 3.5 3.4 6.7 6.6 7.6 9.8 4.4 15.7 13.7 28 27 35.5 18.4 10.4 42.6 10.1 63.2-.6 10.8-5.7 19.5-12.6 26.5-21.1l.4-.4c1.3-1.8 2.5-3.3 3.6-4.4m5.6-10.9c-6.1-3.5-13.6 6.1-16.8 10.1-6.5 8-14.5 14.1-23.6 18.8-17.7 9.2-38.6 9.8-54.7.8-10.4-5.9-18.7-15.8-22.7-30-2.3-8.3-10.6-13.5-15.9-20.2-8.5-10.8-17-13.8-25.5-24.7-3.2-4.1-7.4-19.3-12.5-23.3-.7-.6-1.4-1.1-2.1-1.5-8.6-4.9-15.4 3.7-17.7 11.8-1.7 6-3.8 11.9-6 17.7-11 28.2-27 53.2-49.7 73.4-7.4 6.6-15.3 12.5-22.8 19-12.7 11-25.2 23.1-33.7 37.8-7.3 12.7-11.6 30.5-6.5 44.9 3.1 8.7 10.5 14.2 18.5 18.7 4.8 2.7 9.9 5.1 14.4 7.6 17.1 9.6 34.5 18.9 51.6 28.5 8.4 4.7 16.8 9.6 25.1 14.6 5.9 3.5 12 7.1 17 11.8 10.2 9.7 18 25.6 22.7 38.7 3.7 10.5 5.4 28 14.4 35.5 1.5 1.3 3 2.4 4.5 3.2 4.4 2.5 8.9 2.9 14-.2s8.9-9.1 11.2-14.4c11.5-25.7 14.4-56.5 15-84.4.2-8.6.3-17.2 1-25.7 2.4-30 13.1-59 38.4-77.3 6.4-4.6 12.8-9.2 18.9-14.1 5.8-4.7 11.6-9.5 17-14.6 9.9-9.5 19.4-20.4 24.4-33.3 2.2-5.8 10.2-23.2 3.1-28.7-.4-.2-.7-.4-1-.5z"
          />
          <g
            fill="#2EC4B6"
            stroke="#333"
            strokeWidth={6}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit={10}
          >
            <path d="M1113.1 1120.6c-4.6-2.6-10.5-1-13.1 3.6-2.6 4.6-1 10.5 3.6 13.1l55.6 31.3c4.6 2.6 10.5 1 13.1-3.6 2.6-4.6 1-10.5-3.7-13.1l-55.5-31.3zM1080 1179.4c-4.6-2.6-10.5-1-13.1 3.7-2.6 4.6-1 10.5 3.7 13.1l55.6 31.3c4.6 2.6 10.5 1 13.1-3.6 2.6-4.6 1-10.5-3.6-13.1l-55.7-31.4zM1049.6 1235.8c-4.3-3.1-10.3-2.1-13.4 2.2-3.1 4.3-2.1 10.3 2.2 13.4l51.9 37.1c4.3 3.1 10.3 2.1 13.4-2.2 3.1-4.3 2.1-10.3-2.2-13.4l-51.9-37.1z" />
          </g>
          <path
            fill="#2EC4B6"
            stroke="#333"
            strokeWidth={6}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit={10}
            d="M1073 1341.3c-3.3 5.8-10.6 7.8-16.3 4.6l-51.4-29c-5.8-3.3-7.8-10.6-4.6-16.3l14-24.8c3.3-5.8 10.6-7.8 16.3-4.6l51.4 29c5.8 3.3 7.8 10.6 4.6 16.3l-14 24.8zM1097.1 1364c-39.4 4.6 14.8 88.5 25.5 87.2 8.9-1.1 6.3-91-25.5-87.2"
          />
          <g
            fill="#2EC4B6"
            stroke="#333"
            strokeWidth={6}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit={10}
          >
            <circle cx={1135.9} cy={1271} r={11.6} />
            <path d="M1160.8 1317.4c-3 5.7-10 7.8-15.7 4.8-5.7-3-7.8-10-4.8-15.7 3-5.7 10-7.8 15.7-4.8 5.7 3 7.8 10 4.8 15.7z" />
            <circle cx={1161.3} cy={1353.3} r={11.6} />
          </g>
          <g
            fill="#2EC4B6"
            stroke="#333"
            strokeWidth={6}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit={10}
          >
            <circle cx={1409.7} cy={573.4} r={10.5} />
            <circle cx={1514.3} cy={477.5} r={10.5} />
            <circle cx={1430.6} cy={554.2} r={10.5} />
            <circle cx={1451.6} cy={535} r={10.5} />
            <circle cx={1472.5} cy={515.8} r={10.5} />
            <circle cx={1493.4} cy={496.7} r={10.5} />
          </g>
          <path
            fill="#FFD192"
            stroke="#333"
            strokeWidth={9.686}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit={10}
            d="M1147.4 1124.9c31.6 17.6 31 9.2 31 9.2L1445 653.2l-24.1-13.6-.9-.5-24.1-13.6-274.4 477.1s-6.3 3.9 25.1 21.8h0c.2.1.3.2.5.2"
          />
          <path
            fill="#E71D36"
            d="M1422.8 633.9l-19.1-10.8c1.1-4.2.7-9.7-3.4-16-3.3-5 4.5-14.9 14-22 .2-.1.3-.2.5-.4l116.8-107.5c3.4-1.9 7.1-2.8 11.1-2.8 7.7 0 15.5 3.7 20.4 9.6 2.9 3.5 6 9.4 4.4 17.3-1.2 5.8-5.7 12.6-11.3 16.9-3.3 2.5-7.6 3.9-12.1 5.4-4.3 1.4-8.8 2.9-13 5.4-18.5 11.1-23.7 34.1-28.3 54.3-1.8 7.8-3.4 15.1-5.7 21.3-2.5 6.7-7.1 8.9-15.6 12.4-2.7 1.1-5.4 2.2-8.3 3.7-16.4 8.3-25.7 18.5-30.2 24.6l-20.2-11.4z"
          />
          <path
            fill="#EC4A5E"
            d="M1542.7 480.4c6 0 12 2.8 15.8 7.4 2.1 2.5 4.3 6.7 3.2 12.3-.9 4.4-4.7 9.9-9.1 13.3-2.5 1.9-6.3 3.1-10.3 4.4-4.4 1.4-9.4 3.1-14.2 5.9-20.7 12.5-26.2 36.7-31 58.1-1.7 7.6-3.3 14.8-5.5 20.6-1.5 4.1-3.8 5.4-12.2 8.9-2.7 1.1-5.7 2.3-8.7 3.9-14.2 7.1-23.4 15.6-29 22.2l-15.7-8.8-15.5-8.8c.2-4.3-.8-9.7-4.7-15.7.2-1.6 2.6-7 12.3-14.3.3-.2.6-.5.9-.8l116.2-106.9c2.2-1.1 4.8-1.7 7.5-1.7m0-12c-5 0-10 1.2-14.6 3.9l-117.3 107.9c-14.5 10.9-20.4 22.5-15.4 30.1 6.3 9.6.5 15.1.5 15.1l24.1 13.7 25.1 14s7.8-15.6 30.9-27.2c11.2-5.6 22.2-6.8 26.8-19.3 8.4-22.7 8.5-58.7 31.4-72.5 8-4.8 18.2-5.5 25.6-11.1 6.2-4.8 12-12.7 13.6-20.5 3.8-19-13.2-34.1-30.7-34.1z"
          />
          <path
            fill="#333"
            d="M1417.7 643l-24.1-13.7c-1.3-.7-2.2-2-2.4-3.4-.1-1.5-1.6 1.4-.4-.9.6-1.1 4.5-6.5.7-12.2-6.5-9.8-.2-23.6 16.3-36L1525 469.1c.2-.2.5-.4.8-.6 10.5-6.1 23.9-6 35.1.3 13 7.3 19.7 20.9 16.9 34.6-1.7 8.3-7.7 17.3-15.3 23.1-4.7 3.6-10 5.3-15.2 7-3.9 1.3-7.6 2.5-10.8 4.4-14.7 8.8-19.1 28.5-23.5 47.6-1.8 8.1-3.6 15.8-6.1 22.6-4.2 11.4-13 15-21.5 18.5-2.5 1-5.1 2.1-7.6 3.3-21.3 10.7-28.8 25.1-28.9 25.2-.6 1.1-1.5 1.9-2.7 2.3-1.2.4-2.4.2-3.5-.4l-25-14zm-15.7-19.2l20.2 11.4 21.3 11.9c4-5.7 13.2-16.5 30.4-25.2 2.8-1.4 5.6-2.5 8.2-3.6 7.9-3.2 13.6-5.6 16.4-13.2 2.3-6.3 4-13.7 5.8-21.5 4.5-19.9 9.6-42.5 27.6-53.3 4-2.4 8.4-3.9 12.6-5.2 4.7-1.5 9.1-3 12.6-5.6 5.9-4.5 10.6-11.6 11.9-17.8 2.4-11.9-4.9-20.7-12.5-25-8.3-4.7-18.1-4.9-25.7-.6l-116.9 107.6-.3.3c-12.1 9.1-17.8 18.7-14.3 24 4 6.3 4 11.9 2.7 15.8z"
          />
          <path
            fill="none"
            stroke="#333"
            strokeWidth={3}
            strokeLinecap="round"
            strokeMiterlimit={10}
            d="M1424.8 588l-23.1 40.9M1528 491.8l-89 158.1M1445.4 568.8l-36.2 64.3M1466.1 549.5l-49.5 87.8M1486.7 530.3l-62.6 111.2M1507.4 511l-75.9 134.7"
          />
          <g
            fill="#2EC4B6"
            stroke="#333"
            strokeWidth={3}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit={10}
          >
            <path d="M1425.6 673.5c1.6.9 2.1 2.9 1.2 4.4-.9 1.6-2.9 2.1-4.4 1.2l-37.2-21c-1.6-.9-2.1-2.9-1.2-4.4.9-1.6 2.9-2.1 4.4-1.2l37.2 21zM1174 1120.1c1.6.9 2.1 2.9 1.2 4.4-.9 1.6-2.9 2.1-4.4 1.2l-37.2-21c-1.6-.9-2.1-2.9-1.2-4.4.9-1.6 2.9-2.1 4.4-1.2l37.2 21zM1410.8 699.9c1.6.9 2.1 2.9 1.2 4.4s-2.9 2.1-4.4 1.2l-37.2-21c-1.6-.9-2.1-2.9-1.2-4.4.9-1.6 2.9-2.1 4.4-1.2l37.2 21zM1395.9 726.3c1.6.9 2.1 2.9 1.2 4.4-.9 1.6-2.9 2.1-4.4 1.2l-37.2-21c-1.6-.9-2.1-2.9-1.2-4.4s2.9-2.1 4.4-1.2l37.2 21zM1381.1 752.7c1.6.9 2.1 2.9 1.2 4.4-.9 1.6-2.9 2.1-4.4 1.2l-37.2-21c-1.6-.9-2.1-2.9-1.2-4.4s2.9-2.1 4.4-1.2l37.2 21zM1366.2 779c1.6.9 2.1 2.9 1.2 4.4s-2.9 2.1-4.4 1.2l-37.2-21c-1.6-.9-2.1-2.9-1.2-4.4.9-1.6 2.9-2.1 4.4-1.2l37.2 21zM1351.3 805.4c1.6.9 2.1 2.9 1.2 4.4-.9 1.6-2.9 2.1-4.4 1.2l-37.2-21c-1.6-.9-2.1-2.9-1.2-4.4.9-1.6 2.9-2.1 4.4-1.2l37.2 21zM1336.5 831.8c1.6.9 2.1 2.9 1.2 4.4-.9 1.6-2.9 2.1-4.4 1.2l-37.2-21c-1.6-.9-2.1-2.9-1.2-4.4.9-1.6 2.9-2.1 4.4-1.2l37.2 21zM1321.6 858.2c1.6.9 2.1 2.9 1.2 4.4-.9 1.6-2.9 2.1-4.4 1.2l-37.2-21c-1.6-.9-2.1-2.9-1.2-4.4.9-1.6 2.9-2.1 4.4-1.2l37.2 21zM1306.8 884.5c1.6.9 2.1 2.9 1.2 4.4-.9 1.6-2.9 2.1-4.4 1.2l-37.2-21c-1.6-.9-2.1-2.9-1.2-4.4s2.9-2.1 4.4-1.2l37.2 21zM1291.9 910.9c1.6.9 2.1 2.9 1.2 4.4-.9 1.6-2.9 2.1-4.4 1.2l-37.2-21c-1.6-.9-2.1-2.9-1.2-4.4.9-1.6 2.9-2.1 4.4-1.2l37.2 21zM1277 937.3c1.6.9 2.1 2.9 1.2 4.4-.9 1.6-2.9 2.1-4.4 1.2l-37.2-21c-1.6-.9-2.1-2.9-1.2-4.4.9-1.6 2.9-2.1 4.4-1.2l37.2 21zM1262.2 963.7c1.6.9 2.1 2.9 1.2 4.4s-2.9 2.1-4.4 1.2l-37.2-21c-1.6-.9-2.1-2.9-1.2-4.4s2.9-2.1 4.4-1.2l37.2 21zM1247.7 990.3c1.6.9 2.1 2.9 1.2 4.4-.9 1.6-2.9 2.1-4.4 1.2l-37.2-21c-1.6-.9-2.1-2.9-1.2-4.4.9-1.6 2.9-2.1 4.4-1.2l37.2 21zM1235.5 1011.9c1.6.9 2.1 2.9 1.2 4.4-.9 1.6-2.9 2.1-4.4 1.2l-37.2-21c-1.6-.9-2.1-2.9-1.2-4.4.9-1.6 2.9-2.1 4.4-1.2l37.2 21zM1223.3 1033.6c1.6.9 2.1 2.9 1.2 4.4-.9 1.6-2.9 2.1-4.4 1.2l-37.2-21c-1.6-.9-2.1-2.9-1.2-4.4.9-1.6 2.9-2.1 4.4-1.2l37.2 21zM1210.7 1055.1c1.6.9 2.1 2.9 1.2 4.4-.9 1.6-2.9 2.1-4.4 1.2l-37.2-21c-1.6-.9-2.1-2.9-1.2-4.4.9-1.6 2.9-2.1 4.4-1.2l37.2 21zM1198.5 1076.7c1.6.9 2.1 2.9 1.2 4.4s-2.9 2.1-4.4 1.2l-37.2-21c-1.6-.9-2.1-2.9-1.2-4.4.9-1.6 2.9-2.1 4.4-1.2l37.2 21zM1186.3 1098.4c1.6.9 2.1 2.9 1.2 4.4-.9 1.6-2.9 2.1-4.4 1.2l-37.2-21c-1.6-.9-2.1-2.9-1.2-4.4.9-1.6 2.9-2.1 4.4-1.2l37.2 21z" />
            <circle cx={1412.4} cy={652.4} r={4.2} />
            <circle cx={1159.5} cy={1101.4} r={4.2} />
            <circle cx={1382.7} cy={705.2} r={4.2} />
            <circle cx={1353} cy={758} r={4.2} />
            <circle cx={1323.3} cy={810.7} r={4.2} />
            <circle cx={1293.5} cy={863.5} r={4.2} />
            <circle cx={1263.8} cy={916.2} r={4.2} />
            <circle cx={1208.8} cy={1014.9} r={4.2} />
            <circle cx={1183.9} cy={1058} r={4.2} />
            <circle cx={1226.8} cy={964.9} r={4.2} />
            <circle cx={1242.2} cy={973.5} r={4.2} />
          </g>
          <g
            fill="#2EC4B6"
            stroke="#333"
            strokeWidth={3}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit={10}
          >
            <circle cx={1424.6} cy={588.4} r={4.2} />
            <circle cx={1528} cy={491.8} r={4.2} />
            <circle cx={1445.3} cy={569} r={4.2} />
            <circle cx={1465.9} cy={549.7} r={4.2} />
            <circle cx={1486.6} cy={530.4} r={4.2} />
            <circle cx={1507.3} cy={511.1} r={4.2} />
          </g>
          <path
            fill="#2EC4B6"
            stroke="#333"
            strokeWidth={6}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit={10}
            d="M1023.2 1299.4c-3.3-1.8-7.4-.7-9.2 2.6-1.8 3.3-.7 7.4 2.6 9.2l39.2 22.1c3.3 1.8 7.4.7 9.2-2.6 1.8-3.3.7-7.4-2.6-9.2l-39.2-22.1z"
          />
          <g
            stroke="#333"
            strokeWidth={3}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit={10}
          >
            <path fill="none" d="M1168.6 1286.9l6.2-35.1" />
            <path
              fill="#2EC4B6"
              d="M1174.4 1272.6c-1.8 1.5-4.4 1.3-5.9-.5s-1.3-4.4.5-5.9 4.4-1.3 5.9.5c1.5 1.7 1.3 4.4-.5 5.9z"
            />
          </g>
          <g fill="#333">
            <path d="M1165.1 1398.2c-1-.5-2.2-.2-2.7.8s-.2 2.2.8 2.7 2.2.2 2.7-.8c.5-.9.2-2.2-.8-2.7z" />
            <circle cx={1271.8} cy={1164} r={2} />
            <circle cx={1120.7} cy={1075.2} r={2} />
            <circle cx={1214.1} cy={1173.2} r={2} />
            <circle cx={1078.1} cy={1151.1} r={2} />
            <circle cx={1023.3} cy={1201.9} r={2} />
            <circle cx={1005} cy={1256.5} r={2} />
            <circle cx={1123.4} cy={1327.2} r={2} />
            <path d="M1199.1 1234.8c-1-.5-2.2-.2-2.7.8s-.2 2.2.8 2.7 2.2.2 2.7-.8c.5-.9.2-2.1-.8-2.7z" />
            <circle cx={1119.6} cy={1440.8} r={2} />
            <path d="M1097.4 1370.5c-1-.5-2.2-.2-2.7.8s-.2 2.2.8 2.7 2.2.2 2.7-.8c.5-.9.2-2.1-.8-2.7z" />
            <circle cx={1023.8} cy={1279.3} r={2} />
            <circle cx={1078.5} cy={1310.1} r={2} />
          </g>
          <g fill="none" id="strings">
            <path
              stroke="#333"
              strokeWidth={3}
              strokeLinecap="round"
              strokeMiterlimit={10}
              d="M1401.5 629.3l-317.4 563.3-60.4 107.2M1408.9 633.5l-317.3 563.3-60.4 107.2M1416.4 637.7L1099 1201l-60.4 107.2M1423.8 641.9l-317.3 563.3-60.4 107.2M1431.3 646.1l-317.4 563.3-60.4 107.2M1438.7 650.3l-317.3 563.3-60.4 107.1"
            />
            <path d="M1401.5 629.3l-313.7 565.5-64.1 105M1408.9 633.5L1095.3 1199l-64.1 105M1416.4 637.7l-313.7 565.5-64.1 105M1423.8 641.9l-313.6 565.5-64.1 105M1431.3 646.1l-313.7 565.5-64.1 105M1438.7 650.3L1125 1215.8l-64 104.9" />
          </g>
          <g id="notes_2_">
            <path
              className="notes"
              id="note-4_2_"
              fill="#FDE74C"
              stroke="#000000"
              strokeWidth="6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              d="
            M1465,857.2l34.5-36.9c2-2.2,1.9-5.6-0.3-7.7l-32.5-30.4c-2.2-2-5.6-1.9-7.7,0.3l-30.5,32.6c-1.2-2.1-2.9-4-5-5.5
            c-7.3-5.3-17.2-4.3-22,2.4c-4.8,6.6-2.7,16.3,4.6,21.6c7.1,5.1,16.1,4,21.4-1.7l35.6-38.1l24.6,23l-21.7,23.2
            c-1.2-2.1-2.9-4-5-5.5c-7.3-5.3-17.2-4.3-22,2.4c-4.8,6.6-2.7,16.3,4.6,21.6C1450.8,863.6,1459.8,862.8,1465,857.2z"
            />

            <path
              className="notes"
              id="note-3_2_"
              fill="#FDE74C"
              stroke="#000000"
              strokeWidth="6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              d="
            M1349.1,620.8l8.1-49.8c0.5-3-1.5-5.7-4.5-6.2l-43.9-7.2c-3-0.5-5.7,1.5-6.2,4.5l-7.2,44.1c-2.1-1-4.6-1.7-7.2-1.8
            c-9.1-0.3-16.6,6-16.9,14.2c-0.3,8.2,6.8,15,15.9,15.4c8.7,0.3,15.6-5.6,16.9-13.3l8.4-51.5l33.3,5.4l-5.1,31.4
            c-2.2-1.1-4.6-1.7-7.2-1.8c-9.1-0.3-16.6,6-16.9,14.2c-0.3,8.2,6.8,15,15.9,15.4C1340.9,634.1,1347.9,628.4,1349.1,620.8z"
            />

            <path
              className="notes"
              id="note-2_2_"
              fill="#FDE74C"
              stroke="#000000"
              strokeWidth="6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              d="
            M1554,697.1c2-8.1-0.7-17.1-7.9-26.6l0,0c-0.5-0.7-1-1.4-1.6-2c-4-4.4-7.7-4-9.6-2.3l-33.1,30l0,0c-1.1-2.2-2.6-4.2-4.5-5.9
            c-3.3-2.9-7.5-4.4-11.6-4.3c-4.2,0.1-7.9,1.8-10.5,4.8c-4.8,5.6-4.3,14.3,1.2,20.3c0.5,0.6,1.1,1.1,1.6,1.6
            c6.4,5.5,15.5,5.6,21.5,0.1l32.5-29.5c0.5,0.4,0.9,0.9,1.3,1.4c5,5.5,7.3,12.6,6.6,20.6c-0.3,3.3-1,6.1-1.5,7.8
            c-0.1,0.4,0,0.9,0.4,1.2c0.4,0.3,0.9,0.3,1.2,0.1C1544.2,711.9,1551.7,706.1,1554,697.1z"
            />

            <path
              className="notes"
              id="note-1_2_"
              fill="#FDE74C"
              stroke="#000000"
              strokeWidth="6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              d="
				M1293.9,711.3c-1.6-8.2-7.7-15.3-18.3-20.8l0,0c-0.8-0.4-1.5-0.8-2.2-1.1c-5.5-2.3-8.6-0.4-9.6,1.9l-17.5,41.1l0,0
				c-1.9-1.6-4.1-2.8-6.5-3.4c-4.2-1.2-8.6-0.9-12.3,1c-3.7,1.8-6.4,4.9-7.5,8.7c-2,7,2.1,14.8,9.6,17.9c0.7,0.3,1.4,0.6,2.2,0.8
				c8.1,2.3,16.4-1.4,19.6-8.9l17.2-40.3c0.6,0.2,1.2,0.4,1.8,0.7c6.8,2.9,11.9,8.4,14.6,16c1.1,3.1,1.6,5.9,1.9,7.8
				c0.1,0.4,0.4,0.8,0.8,0.9c0.4,0.1,0.9-0.1,1.2-0.5C1291.3,728.8,1295.7,720.4,1293.9,711.3z"
            />
          </g>
        </g>
      </svg>
    </>
  );
}

const MemoGuitar = React.memo(Guitar);
export default MemoGuitar;
